import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import AlertPop from "@components/common/popup/AlertPop";
import AutoNicknamePop from "@components/common/popup/AutoNicknamePop";
import CertificationLoginPop from "@components/common/popup/CertificationLoginPop";
import CmmConfirmPop2 from "@components/common/popup/CmmConfirmPop2";
import CmmFindIdPop from "@components/common/popup/communityjoin/CmmFindIdPop";
import CmmFindPwdPop from "@components/common/popup/communityjoin/CmmFindPwdPop";
import CmmJoinCompanyPop from "@components/common/popup/communityjoin/CmmJoinCompanyPop";
import CmmJoinDonePop from "@components/common/popup/communityjoin/CmmJoinDonePop";
import CmmJoinNewCompanyPop from "@components/common/popup/communityjoin/CmmJoinNewCompanyPop";
import CmmJoinPop from "@components/common/popup/communityjoin/CmmJoinPop";
import CmmLinkageJoinPop from "@components/common/popup/communityjoin/CmmLinkageJoinPop";
import ConfirmPop from "@components/common/popup/ConfirmPop";
import LandingLoginPop from "@components/common/popup/LandingLoginPop";
import { closeBtn } from "@utils/ClickUtils";
import * as CUTIL from "@utils/commUtils";
import { useEffect, useState } from "react";
export const PortalPops = ({ popId, popBody }) => {
    const [popAlertView, setPopAlertView] = useState(_jsx(AlertPop, { popId: null, popBody: null }));
    const [popConfirmView, setPopConfirmView] = useState(_jsx(ConfirmPop, { popId: null, popBody: null }));
    const [popCmmConfirmView2, setPopCmmConfirmView2] = useState(_jsx(CmmConfirmPop2, { popId: null, popBody: null }));
    const [popWhatWeDoView, setPopWhatWeDoView] = useState(_jsx(WhatWeDoPop, { popId: null, popBody: null }));
    const [popAutoNicknameView, setPopLAutoNicknameView] = useState(_jsx(AutoNicknamePop, { popId: null, popBody: null }));
    useEffect(() => {
        // 공통
        setPopAlertView(popAlertView);
        setPopConfirmView(popConfirmView);
        setPopCmmConfirmView2(popCmmConfirmView2);
        //특정 화면
        setPopWhatWeDoView(popWhatWeDoView);
        setPopLAutoNicknameView(popAutoNicknameView);
    }, [popAlertView, popConfirmView, popCmmConfirmView2, popWhatWeDoView, popAutoNicknameView]);
    useEffect(() => {
        handleOpenPop(popId, popBody);
    }, [popId, popBody]);
    function handleOpenPop(popId, popBody) {
        if (popId === "pop-whatwedo") {
            setPopWhatWeDoView(_jsx(WhatWeDoPop, { popBody: popBody }));
        }
        // SEI2.0
        // 커뮤니티 로그인
        // 공통 팝업
        else if (popId === "pop-confirm") {
            setPopConfirmView(_jsx(ConfirmPop, { popBody: popBody }));
        }
        else if (popId === "pop-cmmConfirm1") {
            setPopCmmConfirmView2(_jsx(CmmConfirmPop2, { popBody: popBody }));
        }
        else if (popId === "pop-alert") {
            setPopAlertView(_jsx(AlertPop, { popBody: popBody }));
        }
        else if (popId === "pop-AutoNickname") {
            setPopLAutoNicknameView(_jsx(AutoNicknamePop, { popBody: popBody }));
        }
    }
    return (_jsxs(_Fragment, { children: [popAlertView, popConfirmView, popCmmConfirmView2, popWhatWeDoView, popAutoNicknameView, _jsx(LandingLoginPop, {}), _jsx(CmmFindIdPop, {}), _jsx(CmmFindPwdPop, {}), _jsx(CmmJoinPop, {}), _jsx(CmmJoinDonePop, {}), _jsx(CmmJoinCompanyPop, {}), _jsx(CmmJoinNewCompanyPop, {}), _jsx(CmmLinkageJoinPop, {}), _jsx(CertificationLoginPop, {})] }));
};
export default PortalPops;
function WhatWeDoPop(props) {
    //  body
    const popBody = props.popBody;
    // 닫기 버튼
    const htmlClose = closeBtn(popBody);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-whatwedo", className: "popup-layer js-layer hidden popup-type1 w1130" }, { children: [_jsx("div", Object.assign({ className: "popup__head" }, { children: htmlClose })), CUTIL.isnull(popBody) ? _jsx(_Fragment, {}) : popBody] })) }));
}
